import { Navigation } from "@/components/layout/Navigation";
import { Footer } from "@/components/layout/Footer";
import { type ReactNode } from "react";
import { PageTransition } from "@/components/routing/PageTransition";
import { ErrorBoundary } from "@/components/system/ErrorBoundary";
import { ApplyConfirmationPrompt } from "@/features/apply";
import { ArchiveBanner } from "@/components/archive/ArchiveBanner";
import { ArchiveRouteNotice } from "@/components/archive/ArchiveRouteNotice";

interface MainLayoutProps {
  children: ReactNode;
  hideNavigation?: boolean;
  hideFooter?: boolean;
}

export const MainLayout = ({ children, hideNavigation, hideFooter }: MainLayoutProps) => {
  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 rounded-md bg-background px-4 py-2 shadow"
      >
        Skip to main content
      </a>
      <ErrorBoundary>
        <ArchiveBanner />
      </ErrorBoundary>
      {!hideNavigation && (
        <ErrorBoundary>
          <Navigation />
        </ErrorBoundary>
      )}
      <main id="main-content" className="flex flex-1 flex-col">
        <ErrorBoundary>
          <ArchiveRouteNotice />
        </ErrorBoundary>
        <PageTransition>
          {children}
        </PageTransition>
      </main>
      <ErrorBoundary>
        <ApplyConfirmationPrompt />
      </ErrorBoundary>
      {!hideFooter && (
        <ErrorBoundary>
          <Footer />
        </ErrorBoundary>
      )}
    </div>
  );
};

export default MainLayout;
